import { Component, input, OnInit, output } from '@angular/core';
import { Router } from '@angular/router';
import { BaseConfigurableComponent } from '@app/base-config.component';

@Component({
  selector: 'afcu-list',
  standalone: true,
  imports: [],
  templateUrl: './list.component.html'
})
export class ListComponent extends BaseConfigurableComponent implements OnInit{

  externalFunction = output<{ function: string; value: CategorySelected | Branch }>()
  
  service = input<minifyServiceGroup>()
  branchInformation = input<Branch>()

  title: string = ''
  description: string = ''
  duration: number = 0

  constructor(private router: Router){
    super('minutes')
  }

  ngOnInit(): void {
    if (this.service()){
      this.title = this.service()?.name!
      this.description = this.service()?.description!
      this.duration = this.service()?.duration!
    }else if (this.branchInformation()){
      this.title = this.branchInformation()?.locationName!
      this.description = this.branchInformation()?.address!
    }
  }

  goTo() {
    if (this.service()){
      this.externalFunction.emit({
        function: 'selectService',
        value: {description: this.service()?.name!}
      })  
    }

    if (this.branchInformation()){
      this.externalFunction.emit({
        function: 'selectBranch',
        value: this.branchInformation() as Branch
      }) 
      this.router.navigate([`/services`, this.branchInformation()?.branchID], {queryParamsHandling: 'merge'})
    }
  }

}
